import { useEffect, useState } from "react"
import { getError, openNotification, tryCatch } from "../common/constants/Utilities";
import { useAuth } from "../contexts/auth";
import { IPuesto } from "../interfaces/IPuesto";
import { getPuestosByUserID } from "../services/user";


const useListPuesto = () => {

    // States
    const { user } = useAuth();
    const [listPuesto, setListPuesto] = useState<IPuesto[]>([]);
    const [loadingPuesto, setLoadingPuesto] = useState<boolean>(true);

    // Effects
    useEffect(() => {
        handleGetPuestosByUserID();
    }, [user]);

    // Handles
    const handleGetPuestosByUserID = () => {
        setLoadingPuesto(true);
        tryCatch(() => {
            getPuestosByUserID(user!.usuarioID)
                .then((response) => {
                    setListPuesto(response.data);
                })
                .catch((response) => {
                    openNotification('error', 'Error', getError(response?.msg));
                })
                .finally(() => setLoadingPuesto(false));
        })

    }

    return {
        listPuesto,
        loadingPuesto
    }
}


export default useListPuesto;